import Star from '@/app/_components/ui/icons/Star.svg';
import LStarFilled from '@/app/_components/ui/icons/LStarFilled.svg';
import React from 'react';

export default function AverageRating({ score, size }) {
  return (
    <div className="relative">
      <div className="flex">
        {[...Array(5)].map((star, index) => (
          <React.Fragment key={index}>
            {size == 'small' ? (
              <Star fill="#b2b2b2" />
            ) : (
              <LStarFilled fill="#b2b2b2" />
            )}
          </React.Fragment>
        ))}
      </div>
      <div
        className="absolute inline-flex whitespace-nowrap left-0 right-0"
        style={{ top: 0, width: `${score * 20}%`, overflow: 'hidden' }}
      >
        {[...Array(5)].map((star, index) => (
          <React.Fragment key={index}>
            {size == 'small' ? (
              <div key={index} style={{ width: '27px' }}>
                <Star fill="#FFD659" />
              </div>
            ) : (
              <div key={index} style={{ width: '27px' }}>
                <LStarFilled fill="#FFD659" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
